import { HERRAMIENTA_SELECCIONAR, HERRAMIENTAS_CARGAR, HERRAMIENTAS_TOGGLE, INICIALIZAR } from '../actions';
import { combineReducers } from 'redux';
import * as HERRAMIENTAS from '../herramientas/constantes';

var grupoSeleccionado = function grupoSeleccionado() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : HERRAMIENTAS.GRUPO_PIZARRA;
  var action = arguments[1];

  switch (action.type) {
    case HERRAMIENTA_SELECCIONAR:
      return action.grupo;

    default:
      return state;
  }
};

var herramientaIdSeleccionado = function herramientaIdSeleccionado() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : HERRAMIENTAS.PUNTERO_ID;
  var action = arguments[1];

  switch (action.type) {
    case HERRAMIENTA_SELECCIONAR:
      if (HERRAMIENTAS.HERRAMIENTAS_NO_SELECCIONABLES.find(function (id) {
        return id === action.herramientaId;
      })) {
        return state;
      }

      return action.herramientaId;

    default:
      return state;
  }
};

var botones = function botones() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : HERRAMIENTAS.BARRA_HERRAMIENTAS_POR_DEFECTO.botones;
  var action = arguments[1];

  switch (action.type) {
    case INICIALIZAR:
      return action.config.configHerramientas.botones;

    case HERRAMIENTAS_CARGAR:
      return action.botones || state;

    default:
      return state;
  }
};

var posicion = function posicion() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : HERRAMIENTAS.BARRA_HERRAMIENTAS_POR_DEFECTO.posicion;
  var action = arguments[1];

  switch (action.type) {
    case INICIALIZAR:
      return action.config.configHerramientas.posicion;

    case HERRAMIENTAS_CARGAR:
      return action.posicion || state;

    default:
      return state;
  }
};

var visible = function visible() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  switch (action.type) {
    case INICIALIZAR:
      return action.config.configHerramientas.visible;

    case HERRAMIENTAS_CARGAR:
      return action.visible || state;

    case HERRAMIENTAS_TOGGLE:
      return !state;

    default:
      return state;
  }
};

var punteroAlOcultar = function punteroAlOcultar() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case INICIALIZAR:
      return action.config.configHerramientas.punteroAlOcultar || false;

    default:
      return state;
  }
};

var barraHerramientas = combineReducers({
  botones: botones,
  visible: visible,
  punteroAlOcultar: punteroAlOcultar,
  posicion: posicion,
  grupoSeleccionado: grupoSeleccionado,
  herramientaIdSeleccionado: herramientaIdSeleccionado
});
export default barraHerramientas;